import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';

import { api } from '@services';
import { VotePublicQuestionResponse } from '@common/types/api/public-questions/response';

export const usePublicQuestionVoteMutation = (roomId?: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (questionId: number) => {
      const { data } = await api.post<VotePublicQuestionResponse>(
        `/rooms/${roomId}/public-questions/${questionId}/vote`,
      );
      return data;
    },
    {
      onSuccess: () => {
        // Não mostrar toast para melhor UX no toggle de votos
        queryClient.invalidateQueries(['public-questions', roomId]);
      },
      onError: (err: AxiosError<{ message: string }>) => {
        const message =
          err.response?.data?.message || 'Erro ao votar. Tente novamente.';
        toast.error(message);
      },
    },
  );
};
